import React from 'react';
import './cta.css';

const Cta = () => {
    return (
        <div className="gpt3__cta">
            <div className="gpt3__cta-content">
                <p>Request early access to get started</p>
                <h3>Register today &amp; start exploring the endless possiblities.</h3>
            </div>
            <div className="gpt3__cta-btn">
                <button type='button'>Get started</button>
            </div>
        </div>
    )
}

export default Cta
